import "./greetings.scss";
import { Context } from "../../Reducers/Store";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";

function Greetings() {
  const [state, _] = useContext(Context);

  let navigate = useNavigate();

  const handleAddNewEvent = () => {
    return navigate("/newEvent", { replace: false });
  };

  const handleAddNewVolunteer = () => {
    return navigate("/users/new", { replace: false });
  };

  return (
    <>
      <Row>
        <Col className="col-md-12">
          <div className="greetings-container">
            <Col className="col-md-12 top-banner">
              <h4>
                Hello, {state.profile?.firstName} {state.profile?.lastName}
              </h4>
              <p>
                Welcome back, <br />
                your dashboard is ready!
              </p>
              {state.profile?.role == "ROLE_CHURCH_ADMIN" &&
                <>
                  <Button className="button-new-event" onClick={handleAddNewEvent}>
                    Add New Event
                  </Button>
                  <Button
                    className="button-new-volunteer"
                    onClick={handleAddNewVolunteer}
                  >
                    Add New Team Member
                  </Button>
                </>
              }
            </Col>
          </div>
        </Col>
      </Row><Row>
        <Col className="col-md-12">
          <h6 className="chuch-name-dash">
            {state.church?.name}
          </h6>
        </Col>
      </Row>
    </>
  );
}

export default Greetings;
